import { Row, Col } from 'antd';
import { styled } from 'styled-components';
import ScrollAnimation from 'react-animate-on-scroll';

import { ConsultButton } from './ConsultButton';

import img_values_01 from '../assets/img_values_01.png';
import img_values_02 from '../assets/img_values_02.png';
import img_values_03 from '../assets/img_values_03.png';
import img_values_pet from '../assets/img_values_pet.png'
import img_ball_01 from '../assets/img_ball_01.svg';
import img_ball_02 from '../assets/img_ball_02.svg';
import img_ball_03 from '../assets/img_ball_03.svg';

const IntroductionWrapper = styled.div`
    padding: 100px 160px;
    position: relative;
    z-index: 10;

    @media screen and (max-width: 768px) {
        padding: 60px 20px;
    }
`;

const RowSection = styled(Row)`
    padding: 40px 0px;
`;

const Header = styled.div`
    color: #1385C8;
    font-size: 56px;
    font-weight: bold;
    line-height: 76px;
    width: 100%;
    text-align: center;
    margin-bottom: 20px;

    @media screen and (max-width: 768px) {
        font-size: 36px;
        line-height: 48px;
    }
`;

const LeftCol = styled(Col)`
    padding-right: 20px;

    @media screen and (max-width: 768px) {
        padding-right: 0px;
        margin-bottom: 20px;
    }
`;

const RightCol = styled(Col)`
    padding-left: 20px;

    @media screen and (max-width: 768px) {
        padding-left: 0px;
    }
`;

const SubHeader = styled.div`
    color: #101720;
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    width: 100%;
    text-align: center;

    span {
        color: #45B9AE;
        margin: 0px 5px;
    }
`;

const TopicHeader = styled.div`
    color: #1385C8;
    margin-bottom: 32px;
    font-size: 28px;
    font-weight: bold;
    line-height: 40px;
`;

const TopicContent = styled.div`
    background-color: #FFFFFF;
    border-radius: 30px;
    padding: 32px 40px;

    div {
        font-size: 20px;
        font-weight: 400;
        line-height: 32px;

        &:nth-child(n+2) {
            margin-top: 40px;
        }

        .title {
            color: #1385C8;
            font-size: 24px;
            font-weight: bold;
            line-height: 36px;
        }
    }
`;

const Ball1 = styled.img`
    width: 50px;
    position: absolute;
    top: 100px;
    right: 470px;
    z-index: -1;

    @media screen and (max-width: 768px) {
        width: 40px;
        top: 30px;
        right: 85px;
    }
`;

const Ball2 = styled.img`
    width: 160px;
    position: absolute;
    top: 930px;
    left: 120px;
    z-index: -1;

    @media screen and (max-width: 768px) {
        width: 120px;
        top: 1185px;
        left: 10px;
    }
`;

const Ball3 = styled.img`
    width: 300px;
    position: absolute;
    bottom: 260px;
    right: 0px;
    z-index: -1;

    @media screen and (max-width: 768px) {
        width: 200px;
        bottom: 360px;
        right: 0px;
    }
`;

const Introduction = () => {
    return (
        <IntroductionWrapper>
            <Header>促進企業健康新助力</Header>
            <SubHeader>
                Workute 協助
                <span>職場護理師、人資、福委會</span>
                輕鬆打造運動文化，實現 ESG 人才永續目標！
            </SubHeader>
            <div style={{ margin: '60px 0px' }}>
                <RowSection>
                    <LeftCol md={12} sm={24} xs={24}>
                        <ScrollAnimation animateIn='bounceInLeft' animateOnce duration={1.5}>
                            <img src={img_values_01} alt='img_values_01' style={{ width: '100%' }} />
                        </ScrollAnimation>
                    </LeftCol>
                    <RightCol md={12} sm={24} xs={24} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <ScrollAnimation animateIn='bounceInRight' animateOnce duration={1.5}>
                            <TopicHeader>
                                創新運動競賽，有效提升員工參與度
                            </TopicHeader>
                            <TopicContent>
                                <div>
                                    <div className='title'>跳脫傳統健促模式，玩出健康新高度</div>
                                    Workute 創新賽事設計與靈活多元的賽制安排，激勵員工持續參與活動，幫助養成運動習慣。
                                </div>
                                <div>
                                    <div className='title'>員工運動數據快速掌握，輕鬆建立有效健促策略</div>
                                    Workute 企業專屬管理後台數據化呈現活動成效，協助制定精準的健康促進方案。
                                </div>
                            </TopicContent>
                        </ScrollAnimation>
                    </RightCol>
                </RowSection>
                <RowSection>
                    <LeftCol md={12} sm={24} xs={24} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <ScrollAnimation animateIn='bounceInLeft' animateOnce duration={1.5}>
                            <TopicHeader>
                                輕鬆搞定 Team Building，凝聚員工向心力
                            </TopicHeader>
                            <TopicContent>
                                <div>
                                    <div className='title'>強化異地團隊的互動和連結</div>
                                    Workute 線上競賽讓不同地點的員工皆能同步參加賽事，異地團隊也能輕鬆提升向心力。
                                </div>
                                <div>
                                    <div className='title'>活動建立流程簡單又高效</div>
                                    Workute 平台快速建立賽事，隨時查看統計數據，大幅節省籌備團隊時間與人力。
                                </div>
                            </TopicContent>
                        </ScrollAnimation>
                    </LeftCol>
                    <RightCol md={12} sm={24} xs={24}>
                        <ScrollAnimation animateIn='bounceInRight' animateOnce duration={1.5}>
                            <img src={img_values_02} alt='img_values_02' style={{ width: '100%' }} />
                        </ScrollAnimation>
                    </RightCol>
                </RowSection>
                <RowSection>
                    <LeftCol md={12} sm={24} xs={24}>
                        <ScrollAnimation animateIn='bounceInLeft' animateOnce duration={1.5}>
                            <img src={img_values_03} alt='img_values_03' style={{ width: '100%' }} />
                        </ScrollAnimation>
                    </LeftCol>
                    <RightCol md={12} sm={24} xs={24} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <ScrollAnimation animateIn='bounceInRight' animateOnce duration={1.5}>
                            <TopicHeader>
                                打造健康職場環境，加速企業 ESG 進程
                            </TopicHeader>
                            <TopicContent>
                                <div>
                                    <div className='title'>健促活動助力企業ESG目標</div>
                                    Workute 一鍵生成健康促進計畫與報告，協助企業實現員工健康福祉的 ESG 指標。
                                </div>
                            </TopicContent>
                        </ScrollAnimation>
                    </RightCol>
                </RowSection>
            </div>
            <Row style={{ display: 'flex', justifyContent: 'center', marginBottom: '100px' }}>
                <ConsultButton />
            </Row>
            <Row style={{ position: 'absolute', bottom: 0, left: '80px' }}>
                <Col md={24} sm={0} xs={0}>
                    <img src={img_values_pet} alt='img_values_pet' style={{ width: '340px', transform: 'translateY(5px)' }} />
                </Col>
            </Row>
            <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, zIndex: -2 }}>
                <div style={{ backgroundColor: '#ECF4FD', position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, zIndex: -2 }} />
                <Ball1 src={img_ball_01} alt='img_ball_01' />
                <Ball2 src={img_ball_02} alt='img_ball_02' />
                <Ball3 src={img_ball_03} alt='img_ball_03' />
            </div>
        </IntroductionWrapper>
    );
};

export default Introduction;
